import { useCallback } from "react";
import { useQueryParams } from "src/shared/hooks/queryparams/useQueryParams";

export type ParamsOverride =
  | URLSearchParams
  | ((currentParams: URLSearchParams) => URLSearchParams);

export const usePathHandler = () => {
  const currentParams = useQueryParams();
  return useCallback(
    (path: string, paramsOverride: ParamsOverride = currentParams) => {
      const params: URLSearchParams = (() => {
        if (typeof paramsOverride === "function") {
          return paramsOverride(new URLSearchParams(currentParams));
        }
        return paramsOverride;
      })();
      return `${path}?${params.toString()}`;
    },
    [currentParams],
  );
};
